export default "https://cdn-gra.amplement.io/statics/images/placeholder/placeholderSuggestions@2x.png";